import React, { useEffect, useMemo, useRef } from "react";
import { useOnScreen } from "./useOnScreen";

export const useLoadMoreObserver = ({
  loadMore,
  depArray,
  root,
}: {
  loadMore: () => void;
  depArray?: any[];
  root?: HTMLElement | null;
}): React.ReactNode => {
  const loadMoreRef = useRef(null);
  const isOnScreen = useOnScreen(
    loadMoreRef,
    { root: root || undefined },
    depArray,
  );

  const divElem = useMemo(
    () => (
      <>
        <div className="load-more-observer" ref={loadMoreRef} />
        {/* This adds a spacer to make sure that the observer is never exactly at the bottom
            of the page. */}
        <div style={{ minHeight: 1 }} />
      </>
    ),
    [],
  );

  useEffect(() => {
    if (isOnScreen) {
      loadMore();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOnScreen, ...(depArray || [])]);

  return divElem;
};
